import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { CommitteeDto } from '../shared/dto/committee.dto';
import { CommitteeService } from '../shared/committee.service';
import { NotificationService } from 'src/app/shared';
import { NgForm } from '@angular/forms';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'wl-committee-edit',
  templateUrl: './committee-edit.component.html',
  styleUrls: ['./committee-edit.component.less'],
    standalone: false
})
export class CommitteeEditComponent implements OnInit, OnDestroy {
  @ViewChild('detailsForm') detailsForm: NgForm;
  committeeId: number;
  committee: CommitteeDto;
  isSaving: boolean;

  private subs = new Subscription();
  constructor(
    public securityElementNames: SecurityElementNames,
    private _route: ActivatedRoute,
    private _router: Router,
    private _committeeService: CommitteeService,
    private _notificationService: NotificationService,
    private _observationService: ObservationService,
    private _title: Title
  ) {}

  ngOnInit(): void {
    this.subs.add(
      this._route.params.subscribe((params) => {
        if (params.id) {
          this.committeeId = params.id;
          this.loadCommittee();
        }
      })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  save() {
    this.isSaving = true;
    this._committeeService
      .update(this.committee)
      .then(() => {
        this._notificationService.translateSuccess('committees.edit.committee-details.saved-successfully');
        this._observationService.committeeUpdated(this.committeeId);
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.isSaving = false;
        this.detailsForm?.form.markAsPristine();
      });
  }

  cancel() {
    if (this._router.getCurrentNavigation()?.previousNavigation.finalUrl) {
      this._router.navigateByUrl(this._router.getCurrentNavigation().previousNavigation.finalUrl);
    } else {
      this._router.navigate(['profiles/committees']);
    }
  }

  private loadCommittee() {
    this._committeeService.get(this.committeeId).then((committee) => {
      this.committee = committee;
      this._title.setTitle(committee.Name);
    });
  }
}
